.description {
  padding: 0 20px;
  color: #231E19;

  h3 {
    text-align: center;
    font-family: ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 34px;
    letter-spacing: -0.4px;
    margin-bottom: 8px;
  }

  p {
    color: #7B766F;
    text-align: center;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.051px;
  }
}

// Dark mode
:global body.dark {
  :local {
    .description {
      h3 {
        color: #fffbf2;
      }

      p {
        color: #8B8984;
      }
    }
  }
}
